(function () {
  function swapBg(item) {
    item.style.cssText = item.dataset.bg;
    delete item.dataset.bg;
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-bg]').forEach(swapBg);
    return;
  }

  var swatchObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      // Only swap visible swatches; leave is-hide ones for hover
      entry.target.querySelectorAll('[data-bg]').forEach(function (item) {
        if (!item.closest('.is-hide')) swapBg(item);
      });
      swatchObserver.unobserve(entry.target);
      // Add hover listener to load hidden swatches on first hover
      entry.target.addEventListener('mouseenter', revealHidden, { once: true });
    });
  }, { rootMargin: '200px' });

  function revealHidden(e) {
    e.currentTarget.querySelectorAll('.is-hide [data-bg]').forEach(swapBg);
  }

  function observeSwatchLists(root) {
    (root || document).querySelectorAll('.product-item-meta__swatch-list')
      .forEach(function (el) { swatchObserver.observe(el); });
  }

  observeSwatchLists();

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-item-meta__swatch-list')) {
          swatchObserver.observe(node);
        }
        observeSwatchLists(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
